import { render, staticRenderFns } from "./SpecNews.vue?vue&type=template&id=380ed2f2&scoped=true&"
import script from "./SpecNews.vue?vue&type=script&lang=js&"
export * from "./SpecNews.vue?vue&type=script&lang=js&"
import style0 from "./SpecNews.vue?vue&type=style&index=0&id=380ed2f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ed2f2",
  null
  
)

export default component.exports